import { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControl
} from '@mui/material';
import { CopyToClipboard } from '../universal/JSONHelper';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
import { IsJsonString } from '../universal/JSONHelper';
const store = getStore();


const MergeDensityNetworkConfigs = () => {
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [parentFileContent, setParentFileContent] = useState("");
    const [appliedFileContent, setAppliedFileContent] = useState("");
    const [mergeResult, setMergeResult] = useState("");
    const [errorMessages, setErrorMessages] = useState({});

    useEffect(() => {
        validateForm()
    }, [parentFileContent, appliedFileContent])

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const mergeDensityNetworkConfigs = () => {
        apiClient.post(
            "https://cloud-density-network-ob2apavl4q-uc.a.run.app",
            {
                "is_json_merge_test": true,
                "json_obj_1": parentFileContent,    
                "json_obj_2": appliedFileContent,
            }
        ).then(({ data }) => {
            console.log(data)
            setMergeResult(JSON.stringify(data, null, 2))
            store.updateSuccessMessage("Successfully merged JSON!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Density Network Config")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while creating heat map")
                }
            }
        })
    }

    const validateForm = () => {
        //File Content Section
        if (parentFileContent === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["parent_has_file_content"]: "No file content" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["parent_has_file_content"]: "" }))
        }

        if (!IsJsonString(parentFileContent)) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["parent_is_valid_json"]: "File Content is not valid JSON" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["parent_is_valid_json"]: "" }))
        }

        if (appliedFileContent === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["applied_has_file_content"]: "No file content" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["applied_has_file_content"]: "" }))
        }

        if (!IsJsonString(appliedFileContent)) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["applied_is_valid_json"]: "File Content is not valid JSON" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["applied_is_valid_json"]: "" }))
        }
    }

    const checkSubmitButtonDisabled = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors)
    }

    return (
        <Box>
            <Typography sx={{ marginBottom: '20px' }} variant="h6">Merge Density Network Configs</Typography>
            <Box sx={{ m: 2 }}>
                <FormControl fullWidth>
                    <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', marginBottom: '20px', fontSize: '20px' }}>
                        <Box sx={{ width: '33%', float: "left" }}></Box>
                        <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                            <span sx={{ float: "right" }}><b>Parent File Content:</b></span>
                        </Box>
                        <Box sx={{ width: '33%' }}>
                            <Button
                                onClick={() => CopyToClipboard(parentFileContent)}
                                variant="contained"
                                sx={{ float: "right" }}
                            >
                                Copy to Clipboard
                            </Button>
                        </Box>
                    </Box>
                    {errorMessages["parent_has_file_content"] !== undefined && <Typography color="red">{errorMessages["parent_has_file_content"]}</Typography>}
                    {errorMessages["parent_is_valid_json"] !== undefined && <Typography color="red">{errorMessages["parent_is_valid_json"]}</Typography>}
                    <TextField
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={parentFileContent}
                        maxRows={5000}
                        onChange={(event) => setParentFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                    <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', marginBottom: '20px', fontSize: '20px' }}>
                        <Box sx={{ width: '33%', float: "left" }}></Box>
                        <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                            <span sx={{ float: "right" }}><b>Applied File Content:</b></span>
                        </Box>
                        <Box sx={{ width: '33%' }}>
                            <Button
                                onClick={() => CopyToClipboard(appliedFileContent)}
                                variant="contained"
                                sx={{ float: "right" }}
                            >
                                Copy to Clipboard
                            </Button>
                        </Box>
                    </Box>
                    {errorMessages["applied_has_file_content"] !== undefined && <Typography color="red">{errorMessages["applied_has_file_content"]}</Typography>}
                    {errorMessages["applied_is_valid_json"] !== undefined && <Typography color="red">{errorMessages["applied_is_valid_json"]}</Typography>}
                    <TextField
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={appliedFileContent}
                        maxRows={5000}
                        onChange={(event) => setAppliedFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button
                        variant="contained"
                        onClick={() => mergeDensityNetworkConfigs()}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
            <Box sx={{ m: 2 }}>
                <FormControl fullWidth>
                    <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', marginBottom: '20px', fontSize: '20px' }}>
                        <Box sx={{ width: '33%', float: "left" }}></Box>
                        <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                            <span sx={{ float: "right" }}><b>Output:</b></span>
                        </Box>
                        <Box sx={{ width: '33%' }}>
                            <Button
                                onClick={() => CopyToClipboard(mergeResult)}
                                variant="contained"
                                sx={{ float: "right" }}
                            >
                                Copy to Clipboard
                            </Button>
                        </Box>
                    </Box>
                    
                    <TextField
                        label="File Content"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={mergeResult}
                        maxRows={5000}
                        onChange={(event) => setParentFileContent(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
        </Box>
    )
}

export default MergeDensityNetworkConfigs;